/** Canonical invite param wins over the legacy camelCase one. */
export const BRAND_OPS_INVITE_PARAM = 'brand_ops_invite';
export const BRAND_OPS_INVITE_LEGACY_PARAM = 'brandOpsInvite';

type ParamsLike = { get(name: string): string | null };

export function getBrandOpsInviteToken(params: ParamsLike): string | null {
    return params.get(BRAND_OPS_INVITE_PARAM) || params.get(BRAND_OPS_INVITE_LEGACY_PARAM) || null;
}

/** Legacy `?contractSign=&brandId=` → canonical sign route path (+ optional brandId query). */
export function buildContractSignRedirect(signRoute: string, params: ParamsLike): string | null {
    const contractId = params.get('contractSign');
    if (!contractId) return null;
    const brandId = params.get('brandId');
    const qs = brandId ? `?brandId=${encodeURIComponent(brandId)}` : '';
    return `${signRoute.replace(':contractId', contractId)}${qs}`;
}
